import TextColorPanel from './toolbar/TextColorPanel.js';
import 'react';
import 'prop-types';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-editor-common';
import './constants.js';
import './text-decorations-utils.js';
import './types.js';
import 'wix-rich-content-common';
import './color-scheme-utils.js';
import 'lodash';

const Modals = {
  TEXT_COLOR_PICKER: "TEXT_COLOR_PICKER"
};
const ModalsMap = {
  [Modals.TEXT_COLOR_PICKER]: TextColorPanel
};

export { Modals, ModalsMap };
//# sourceMappingURL=modals.js.map
